import { Contact } from "@plinknz/tah-website-elements";

export enum PhoneType {
  Home = "PH",
  Cell = "PM",
}

interface GetPhoneProps {
  phone: Contact[];
  type: PhoneType;
}

export function getPhone({ phone, type }: GetPhoneProps) {
  if (!phone) {
    return undefined;
  }
  return phone.find((e) => e.typeId === type);
}
